// Защищённый маршрут для студентов: проверяет авторизацию и наличие роли student.

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

/**
 * StudentRoute — доступен для авторизованных пользователей с ролью student.
 * Если не авторизован → /login
 * Если нет роли student → /dashboard
 */
export default function StudentRoute({ children }) {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const fetchMe = useAuthStore((s) => s.fetchMe);

  useEffect(() => {
    if (token && !user) fetchMe();
  }, [token]);

  // Гость — пропускаем без авторизации
  if (!token) return children;

  if (!user) return null; // ждём загрузки профиля

  const hasStudent = user.roles?.includes('student');
  if (!hasStudent) return <Navigate to="/dashboard" replace />;

  return children;
}
